module.exports = function () {
    const accordions = document.querySelectorAll(".accordion");
    if ( !accordions.length ) return;
    
    for (const accordion of accordions) {
        const button = accordion.querySelector(".accordion-button");
        
        button?.addEventListener("click", () => {
            if ( !accordion.closest(".accordion-group") || accordion.classList.contains("active")  ) {
                accordion.classList.toggle("active");
                return;
            }
            
            accordions.forEach(a => {
                if ( a === accordion ) return;
                a.classList.remove("active")
            });
            
            accordion.classList.toggle("active");
        })
    }
}